import FloatingVue from 'floating-vue'

export default defineNuxtPlugin(() => {
  FloatingVue.options.themes = {
    ...FloatingVue.options.themes,
    'ui-tooltip': {
      $extend: 'tooltip',
      distance: 8,
      delay: {
        show: 0,
        hide: 100,
      },
      placement: 'top',
      $resetCss: true,
    },
  }
})
